export default {
  data() {
    return {
      temp: null,
      // ambient temperature 	degrees celsius 	number
      soilTemp: null,
      // relative humidity	percent	number
      wind: null,
      // wind speed	miles per hour	number
      light: null // ambient light level	lux	number
    };
  },

  computed: {
    token() {
      return this.$store.state.token;
    }
  },
  watch: {
    token(newVal) {
      this.getData();
    }
  },
  mounted() {
    // this.getData()
  },
  methods: {
    // 获取气象站数据
    async getData() {
      let params = {
        number: '40261986'
      };
      let {
        data,
        code
      } = await this.$api.getWeatherStationData(params);
      if (code == '200') {
        this.temp = data.temperature + data.temperatureUnit;
        this.soilTemp = data.humidity + data.humidityUnit;
        this.wind = data.windLevel + '级';
        this.light = data.lightIntensity + data.lightIntensityUnit;
      }
      console.log(data, '气象站数据');
    }
  }
};